import { Link, NavLink } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';

import { BrambleMark } from '@/components/bramble-mark';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/components/theme-provider';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/support', label: 'Support' },
];

export function SiteHeader() {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/85 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between gap-4">
        <Link
          to="/"
          className="group flex items-center gap-2.5 rounded-md text-foreground"
          aria-label="Bramble home"
        >
          <BrambleMark className="size-7 transition-transform duration-300 group-hover:-rotate-6" />
          {/* Mark only on a phone: with the wordmark, the nav and theme toggle overflow a
              375px screen (BRA-138). The hero's own "Bramble" sits right below. */}
          <span className="hidden font-display text-[1.35rem] font-semibold tracking-tight sm:inline">
            Bramble
          </span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-3">
          <nav aria-label="Main" className="flex items-center">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'rounded-full px-2.5 py-2 text-sm transition-colors sm:px-4',
                    isActive
                      ? 'text-foreground'
                      : 'text-muted-foreground hover:text-foreground',
                  )
                }
              >
                {({ isActive }) => (
                  <span className="relative">
                    {item.label}
                    <span
                      aria-hidden="true"
                      className={cn(
                        'absolute -bottom-1 left-0 h-[2px] w-full origin-left bg-berry transition-transform duration-300',
                        isActive ? 'scale-x-100' : 'scale-x-0',
                      )}
                    />
                  </span>
                )}
              </NavLink>
            ))}
          </nav>

          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
            title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          >
            {theme === 'dark' ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
          </Button>
        </div>
      </div>
    </header>
  );
}
